import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectAvatar: {
		id: 'project-details.button-for-selecting-an-avatar',
		defaultMessage: 'Change icon',
		description: '',
	},
});
